<div class="form-inline float-right mb-4">
  <div class="form-group pt-4">
    <label for="pageSize" class="font-weight-bold">Rows Displayed</label>
    <select
      [(ngModel)]="pageSize"
      name="pageSize"
      class="form-control mx-sm-3"
      id="pageSize"
      (ngModelChange)="setPage()"
    >
      @for (pageOption of pageOptions; track pageOption) {
        <option [ngValue]="pageOption">{{ pageOption }}</option>
      }
    </select>
  </div>

  <span class="mr-3 pt-4">
    Displaying {{ pageItemRange }} of {{ filteredList.length }} Results
  </span>

  @if (totalPages > 1) {
    <ngb-pagination
      [collectionSize]="filteredList.length"
      [(page)]="page"
      [maxSize]="2"
      (pageChange)="setPage($event)"
      class="pagination pt-3"
      [pageSize]="pageSize"
      [boundaryLinks]="true"
    >
      <ng-template ngbPaginationFirst>First</ng-template>
      <ng-template ngbPaginationPrevious>Previous</ng-template>
      <ng-template ngbPaginationNext>Next</ng-template>
      <ng-template ngbPaginationLast>Last</ng-template>
    </ngb-pagination>
  }
</div>
